import React from 'react';

export const IconSmallCloseLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M12 10.586L7.757 6.343 6.343 7.757 10.586 12l-4.243 4.243 1.414 1.414L12 13.414l4.243 4.243 1.414-1.414L13.414 12l4.243-4.242-1.414-1.415L12 10.586z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
